import { InjectionToken } from "@angular/core";

export const SessionTimeoutWarningConfigToken: InjectionToken<SessionTimeoutWarningConfig> = new InjectionToken<SessionTimeoutWarningConfig>("components.session.timeout.warning.config");

/**
 * Configuration for session timeout warning component.
 */
export interface SessionTimeoutWarningConfig {
    /**
     * How many seconds before the timeout should the warning message appear for an inactive user.
     */
    timeoutWarningTime: number;
}
